import { default as ReactSelect } from 'react-select';
import DropdownIndicator from '../DropdownIndicator';
import styles from './Select.module.scss';

const Select = (props) => {
  return (
    <div className={`${styles.wrapper} ${props.disabled ? styles.disabled : ''}`}>
      {props.title && <h4>{props.title}</h4>}
      <ReactSelect {...props} components={{ DropdownIndicator }} />
    </div>
  );
};

export default Select;
